import React from 'react'
import { Divider, Button, Popconfirm, Space } from 'antd'

import { DownOutlined, UpOutlined } from '@ant-design/icons'

const removeMessage = (
  <>
    <div>Are you sure?</div>
    <div> If it does not have releated data it will be delete.</div>
  </>
)
const confirmationMessage = 'Are you sure?'

/**
 * Columna Action básica con Toggle y Delete links
 */
export const basicDeleteActionField = (props) => {
  return {
    title: 'Action',
    key: 'action',
    render: (text, record) => {
      return (
        <Space size='small' split={<Divider type='vertical' />}>
          {props.toggle && (
            <Popconfirm
              title={confirmationMessage}
              onConfirm={() => props.toggle(record.id)}
              okText='Yes'
              cancelText='No'
            >
              <Button size='small' type='link' disabled={props.loading}>
                {record.active ? 'Disable' : 'Enable'}
              </Button>
            </Popconfirm>
          )}
          {props.remove && (
            <Popconfirm
              title={removeMessage}
              onConfirm={() => props.remove(record.id)}
              okText='Yes'
              cancelText='No'
            >
              <Button size='small' type='link' disabled={props.loading}>
                Delete
              </Button>
            </Popconfirm>
          )}
        </Space>
      )
    }
  }
}

/**
 * Analizar si se va a utilizar o no
 */
export const basicToggleWithDelete = (props) => {
  return {
    title: 'Action',
    key: 'action',
    render: (text, record) => {
      let title = <div>Are you sure?</div>

      title = record.active ? (
        <>
          {' '}
          {title} <div> If it does not have releated data it will be delete.</div>{' '}
        </>
      ) : (
        title
      )

      return (
        <div>
          <Popconfirm
            title={title}
            onConfirm={() => props.toggle(record.id, record.active)}
            okText='Yes'
            cancelText='No'
          >
            {record.active ? (
              <Button icon={<DownOutlined />} size='small'>
                Disable
              </Button>
            ) : (
              <Button icon={<UpOutlined />} size='small'>
                Enable
              </Button>
            )}
          </Popconfirm>
        </div>
      )
    }
  }
}
